import { deepFreeze } from '@prophecy/utils/data';
export class CacheManager {
    getTimeoutKey(key) {
        return this.cacheTTLTimeouts.get(JSON.stringify(key));
    }
    deleteTimeoutKey(key) {
        this.cacheTTLTimeouts.delete(JSON.stringify(key));
    }
    setTimeoutKey(key, timeout) {
        this.cacheTTLTimeouts.set(JSON.stringify(key), timeout);
    }
    setData(key, value) {
        const freezedValue = deepFreeze(value);
        this.queryClient.setQueryData(key, freezedValue);
    }
    clearCacheTTLTimeout(key) {
        const timeout = this.getTimeoutKey(key);
        if (timeout) {
            clearTimeout(timeout);
            this.deleteTimeoutKey(key);
        }
    }
    constructor(queryClient) {
        this.cacheTTLTimeouts = new Map();
        this.queryClient = queryClient;
    }
    get(key) {
        return this.queryClient.getQueryData(key);
    }
    set(key, value, ttl = Infinity) {
        this.updateTTL(key, ttl);
        this.setData(key, value);
    }
    updateTTL(key, ttl) {
        this.clearCacheTTLTimeout(key);
        if (ttl !== Infinity && ttl > 0) {
            const timeout = setTimeout(() => {
                this.remove(key, true);
            }, ttl);
            this.setTimeoutKey(key, timeout);
        }
    }
    getOrCompute(key, queryFn, ttl) {
        const queryState = this.queryClient.getQueryState(key);
        this.updateTTL(key, ttl !== null && ttl !== void 0 ? ttl : Infinity);
        if (queryState === null || queryState === void 0 ? void 0 : queryState.data) {
            return queryState.data;
        }
        const newData = queryFn();
        this.setData(key, newData);
        return newData;
    }
    remove(key, exact = false) {
        this.queryClient.removeQueries({ queryKey: key, exact });
        this.clearCacheTTLTimeout(key);
    }
    clear(predicate) {
        if (predicate) {
            this.queryClient.removeQueries({
                predicate: (query) => predicate(query.queryKey)
            });
            this.cacheTTLTimeouts.forEach((timeout, keyString) => {
                const predicateKey = JSON.parse(keyString);
                if (predicate(predicateKey)) {
                    clearTimeout(timeout);
                    this.cacheTTLTimeouts.delete(keyString);
                }
            });
        }
        else {
            this.queryClient.clear();
            this.cacheTTLTimeouts.forEach((timeout) => {
                clearTimeout(timeout);
            });
            this.cacheTTLTimeouts.clear();
        }
    }
}
